import { render, staticRenderFns } from "./helps.vue?vue&type=template&id=20589e97&lang=pug&"
import script from "./helps.vue?vue&type=script&lang=js&"
export * from "./helps.vue?vue&type=script&lang=js&"
import style0 from "./helps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports